import Login from 'pages/auth/Login';
import Register from 'pages/auth/Register';
import GuestRoute from 'utils/GuestRoute';

const LoginRoutes = {
  path: '/',
  children: [
    {
      path: 'login',
      element: (
        <GuestRoute>
          <Login />
        </GuestRoute>
      )
    },
    {
      path: 'register',
      element: (
        <GuestRoute>
          <Register />
        </GuestRoute>
      )
    }
  ]
};

export default LoginRoutes;
